<template>
  <section>
<!--    <section>-->
<!--        <Statistics ref="statistics"></Statistics>-->
<!--    </section>-->

    <section>
      <qx-search-box
          class="searchBox"
          :searchBoxData="searchBoxData"
          @sub="sub"
          title="筛选"
          permpisionsQuery
      />
      <TableBox ref="tableBox" />
    </section>
  </section>

</template>

<script>
// import Statistics from './statistics';
import TableBox from './tableBox';
export default {
  components: {
    // Statistics,
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        orgIdOptions: [],
        orderStateOptions: [],
        customerTypeOptions: [],
        form: [
          { // 司机名称
            label: '司机名称',
            value: 'driverName',
            type: 'input',
            placeholder: '请输入司机名称',
          },
          { // 线路名称
            label: '线路名称',
            value: 'lineName',
            type: 'input',
            placeholder: '请输入线路名称',
          },
          { // 装货时间
            label: '装货时间',
            value: 'loadingTime',
            type: 'date',
            placeholder: '请选择装货时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 卸货时间
            label: '卸货时间',
            value: 'unloadTime',
            type: 'date',
            placeholder: '请选择卸货时间',
            attr: {
              type: 'daterange',
            },
          },

        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 装货时间
      if (searchBoxData.loadingTime && searchBoxData.loadingTime.length > 0) {
        searchBoxData.loadingTimeStart = this.formatDate(searchBoxData.loadingTime[0]);
        searchBoxData.loadingTimeEnd = this.formatDate(searchBoxData.loadingTime[1]);
        delete searchBoxData.loadingTime;
      }
      // 卸货时间
      if (searchBoxData.unloadTime && searchBoxData.unloadTime.length > 0) {
        searchBoxData.unloadTimeStart = this.formatDate(searchBoxData.unloadTime[0]);
        searchBoxData.unloadTimeEnd = this.formatDate(searchBoxData.unloadTime[1]);
        delete searchBoxData.unloadTime;
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
